import * as Yup from 'yup'

const postalCodeFormat = (value: string) =>
  /\b[0-9]{5,5}\b/.test(value) || /\b[0-9-]{6,6}\b\b[0-9]{4,4}\b/.test(value)

export const updateAddressSchema = () =>
  Yup.object().shape({
    mailingAddress: Yup.object().shape({
      streetAddress: Yup.object().shape({
        0: Yup.string().required('Required'),
        1: Yup.string(),
      }),
      city: Yup.string().required('Required'),
      state: Yup.string().required('Required'),
      postalCode: Yup.string()
        .test(
          'Postal Code Format',
          'Format is 12345 or 12345-6789',
          //@ts-ignore
          postalCodeFormat
        )
        .required('Required'),
    }),
    homeAddress: Yup.object().shape({
      toggleHomeAddress: Yup.boolean(),
      streetAddress: Yup.object().shape({
        0: Yup.string(),
        1: Yup.string(),
      }),
      city: Yup.string().when('toggleHomeAddress', {
        is: false,
        then: Yup.string().required('Required'),
        otherwise: Yup.string(),
      }),
      state: Yup.string().when('toggleHomeAddress', {
        is: false,
        then: Yup.string().required('Required'),
      }),
      postalCode: Yup.string().when('toggleHomeAddress', {
        is: false,
        then: Yup.string()
          .test(
            'Postal Code Format',
            'Format is 12345 or 12345-6789',
            //@ts-ignore
            postalCodeFormat
          )
          .required('Required'),
      }),
    }),
  })
